export default __webpack_public_path__ + "static/media/image-banner-content.c0e4ec68.svg";